/**
 * 管理帮助文档
 */
export const HELP_LINK_ACTION_UUID = '28882476-d329-4e38-b605-917bd68fe26e'
